/**
 * <s-gift-card-recipient> — gift card recipient form toggle.
 *
 * Wraps a checkbox and a <fieldset data-recipient-fields>. While the checkbox is
 * unchecked the fieldset is disabled, so its inputs are left out of the product
 * form submission and the gift card goes to the buyer as usual. Checking it
 * enables the fields and makes the recipient email required.
 */
class SGiftCardRecipient extends HTMLElement {
  #ac;

  connectedCallback() {
    const checkbox = this.querySelector('input[type="checkbox"][data-recipient-toggle]');
    const fields = this.querySelector('fieldset[data-recipient-fields]');
    if (!checkbox || !fields) return;

    this.#ac = new AbortController();
    const sync = () => {
      fields.disabled = !checkbox.checked;
      fields.hidden = !checkbox.checked;
    };

    checkbox.addEventListener('change', () => {
      sync();
      if (checkbox.checked) fields.querySelector('input[type="email"]')?.focus();
    }, { signal: this.#ac.signal });

    // Today's date in the visitor's timezone; scheduled sends can't be in the past.
    const dateInput = fields.querySelector('input[type="date"]');
    if (dateInput) {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      dateInput.min = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    }

    sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

customElements.define('s-gift-card-recipient', SGiftCardRecipient);
